import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { hasAllDayTimeFrame } from 'shared/utils/timeframe-utils';

import { useWanderingDetectionScenarioConfiguration } from 'features/residents/resident-settings/components/resident-setting-details-scenario-rows/wandering-detection-scenario-configuration/hooks';
import WanderingDetectionSettings from 'features/residents/resident-settings/components/resident-setting-details-scenario-rows/wandering-detection-scenario-configuration/wandering-detection-settings/wandering-detection-settings';
import WanderingDetectionTimeFrames from 'features/residents/resident-settings/components/resident-setting-details-scenario-rows/wandering-detection-scenario-configuration/wandering-detection-time-frame-configuration/wandering-detection-time-frames';
import styles from './wandering-detection-scenario-configuration.module.scss';

type Props = {
  scenarioTitle: string;
  index: number;
};

const WanderingDetectionScenarioConfiguration = ({ scenarioTitle, index }: Readonly<Props>): React.JSX.Element => {
  const { t } = useTranslation('residentsSettings');

  const { configuration, timeFrameConfigurationsChanged, updateResidentSettingEditFormScenario } =
    useWanderingDetectionScenarioConfiguration({ index });

  const titleDescription = t(`scenarioConfiguration.scenarioDescription`);
  const activeAllDay = hasAllDayTimeFrame(configuration.wanderingDetectionTimeFrameConfigurations?.map((item) => item.timeFrame) ?? null);

  return (
    <div className={styles.container}>
      <Typography variant="subtitle1">{`${scenarioTitle} ${titleDescription}`}</Typography>
      <WanderingDetectionTimeFrames
        activeAllDay={activeAllDay}
        index={index}
        wanderingDetectionConfiguration={configuration}
        valuesChanged={timeFrameConfigurationsChanged}
        timeFramesDescription={t('scenarioConfiguration.timeFramesDescriptionAlarm')}
        updateResidentSettingEditFormScenario={updateResidentSettingEditFormScenario}
      />
      {activeAllDay && (
        <WanderingDetectionSettings
          wanderingDetectionConfiguration={configuration}
          activeAllDay={activeAllDay}
          index={0}
          valuesChanged={timeFrameConfigurationsChanged}
          updateResidentSettingEditFormScenario={updateResidentSettingEditFormScenario}
          selectedWanderingBoundaryIds={configuration.wanderingDetectionTimeFrameConfigurations?.flatMap(
            (timeFrameConfig) => timeFrameConfig.wanderingBoundaryLocationIds,
          )}
        />
      )}
    </div>
  );
};

export default WanderingDetectionScenarioConfiguration;
